import Vue from 'vue';
import moment from 'moment';

/**
 * Maps a vue state object to NOP JSON
 * @param {*} map
 * @param {*} vueObject
 */
const mapVueToApi = function (map, vueObject) {
  const apiObject = {};

  map.forEach((prop) => {
    apiObject[prop.apiProperty] = vueObject[prop.vueProperty];
  });

  return apiObject;
};
/**
 *
 * @param {*} map
 * @param {*} apiObject
 * @param {*} state
 * @param {*} updateState false will not update state directly (used for arrays that need to use Vue.set)
 */
const mapApiToVue = function (map, apiObject, state, updateState) {
  const vueObject = {};

  map.forEach((prop) => {
    if (!Array.isArray(prop)) {
      // skip children
      let apiValue = apiObject[prop.apiProperty];

      if (prop.apiProperty.indexOf('.') > 0) {
        const parent = prop.apiProperty.substring(
          0,
          prop.apiProperty.indexOf('.')
        );
        const child = prop.apiProperty.substring(
          prop.apiProperty.indexOf('.') + 1
        );

        if (apiObject[parent]) apiValue = apiObject[parent][child];
      }

      // value processing
      if (prop.type === 'toNumber') {
        apiValue = isNaN(Number(apiValue)) ? 0 : Number(apiValue);
      }
      if (prop.type === 'toDate') {
        apiValue = moment(apiValue).format('YYYY-MM-DD');
      }
      if (prop.type === 'toDateTime') {
        apiValue = moment(apiValue).format('YYYY-MM-DD hh:mm A');
      }
      if (prop.type === 'toBoolean') {
        apiValue = Boolean(apiValue);
      }

      if (updateState) {
        Vue.set(state, prop.vueProperty, apiValue);
        //state[prop.vueProperty] = apiValue
      }

      vueObject[prop.vueProperty] = apiValue;
    }
  });

  return vueObject;
};

export default {
  mapVueToApi,
  mapApiToVue
};
